import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AddCircleOutlineSharpIcon from "@mui/icons-material/AddCircleOutlineSharp";

import {
  Box,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { getTotalAssetsValue } from "../../../services/yourAssets/RealEstateServices";
import { balanceOfAssetsLinks } from "../../../constants/constants";
import { getKeyFromText } from "../../../utils/Utilities";

const TotalAssets = () => {
  const { t } = useTranslation();
  const [totalAssetsValue, setTotalAssetsValue] = useState([]);
  const userId = localStorage.getItem("loggedInUserId");

  useEffect(() => {
    const getListing = async () => {
      let result = await getTotalAssetsValue(userId);
      if (result?.success) {
        let list = [];
        for (let i = 0; i < balanceOfAssetsLinks.length; i++) {
          const element = balanceOfAssetsLinks[i];
          let item = {
            icon: element.image,
            ...result?.payLoad[i],
          };
          list.push(item);
        }
        setTotalAssetsValue([...list]);
      }
    };
    getListing();
  }, []);

  const getTotal = () => {
    let total = 0;
    totalAssetsValue?.forEach((item) => {
      if (item.key === "Loans") {
        total -= item.value;
      } else total += item.value;
    });
    return total.toLocaleString("de-DE");
  };
  return (
    <div>
      <TableContainer
        sx={{ paddingBottom: "0 !impotant", marginBottom: "4rem" }}
        component={Paper}
      >
        <Table
          sx={{
            "th , td": { border: "none" },
          }}
          stickyHeader
          aria-label="sticky table"
        >
          <TableHead>
            <TableRow>
              <TableCell width={"80%"}>
                {t(getKeyFromText("Asset type"))}
              </TableCell>
              <TableCell width={"20%"}>
                {t(getKeyFromText("Total value of the assets"))}
              </TableCell>
              <TableCell width={"0%"}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {totalAssetsValue?.map((item, index) => (
              <React.Fragment>
                <TableRow
                  sx={{
                    backgroundColor: `${
                      index % 2 === 0 ? "color.smokeWhite" : "color.white"
                    }`,
                  }}
                >
                  <TableCell width="80%">
                    {item.icon && (
                      <img src={item.icon} alt={item.key} width="20" />
                    )}{" "}
                    {t(getKeyFromText(item?.key))}
                  </TableCell>
                  <TableCell width="20%">{item?.value.toLocaleString("de-DE")} €</TableCell>
                  <TableCell width="0%"></TableCell>
                </TableRow>
              </React.Fragment>
            ))}
            <TableRow sx={{ background: "#dfc8db" }}>
              <TableCell width="70%" align="right">
                {t("total")}
              </TableCell>
              <TableCell width="20%">{`${getTotal()} € `}</TableCell>
              <TableCell width="0%"></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default TotalAssets;
